import { Trans, useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import ContinueButton from '../../../components/continueButton/ContinueButton';
import { STEPS, TRANSLATION_BUTTON } from '../../constants';
import useCompleteSetupMutation from '../../hooks/useCompleteSetupQuery';

const TRANSLATION_ROOT = `setup.${STEPS.UPDATE_CONDITIONAL_POLICIES}.content`;

// It is for Entra ID configuration on Setup which we will work on in the future
// Ping Shruthi for more info
const UpdateConditionalPolicies = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const { mutate } = useCompleteSetupMutation();

  const error = searchParams.get('error');
  if (error) {
    return <h1>{error}</h1>;
  }

  const handleNextStep = () => {
    mutate(true);
  };

  return (
    <>
      <p>
        <Trans i18nKey={`${TRANSLATION_ROOT}.description`} />
      </p>

      <p>
        <Trans i18nKey={`${TRANSLATION_ROOT}.conditional-access`} />
      </p>

      <p>
        <Trans i18nKey={`${TRANSLATION_ROOT}.exclude-imprivata-entra-id`} />
      </p>

      <ContinueButton label={t(TRANSLATION_BUTTON)} onClick={handleNextStep} />
    </>
  );
};

export default UpdateConditionalPolicies;
